export default "__VITE_ASSET__CamUx7oo__"